export enum GATE_STATUS {
  OPEN = "open",
  OPENING = "opening",
  PARTIAL = "partial",
  CLOSING = "closing",
  CLOSE = "close",
}
